import {ButtonHTMLAttributes, Ref} from 'react';

import {MenuAction} from './MenuAction';

interface MenuButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  ref?: Ref<HTMLButtonElement>;
}

export function MenuButton(props: MenuButtonProps) {
  const {ref, ...rest} = props;
  return <MenuAction as="button" {...rest} ref={ref} tabIndex={-1} />;
}
